import { types, getParent } from 'mobx-state-tree';
import { hasValuesTrait } from '../helper';

export const CenterAdminRow = types
  .model({
    id: types.number,
    name: types.maybeNull(types.string),
    username: types.maybeNull(types.string),
    email: types.maybeNull(types.string),
  })
  .actions(self => ({
    destroy() {
      getParent(self, 2).destroy(self.id);
    },
    ...hasValuesTrait(self),
  }))

export const CenterAdminDetail = types
  .model({
    id: types.maybeNull(types.number),
    name: types.maybeNull(types.string),
    username: types.maybeNull(types.string),
    email: types.maybeNull(types.string),
    password: types.maybeNull(types.string),
  })
  .actions(self => ({
    ...hasValuesTrait(self),
  }))
